import Image from 'next/legacy/image';

const PeopleCard = ({
  name,
  description,
  imagePath,
}: {
  name: string;
  description?: string;
  imagePath: string;
}) => {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="mb-1 p-4">
        <div className="shadow-allSideOuter flex rounded-md">
          <Image src={imagePath} alt={name} height={120} width={120} className="rounded-md" />
        </div>
      </div>
      <div className="-translate-y-4 transform">
        <div className="font-bold">{name}</div>
        <div className="">{description}</div>
      </div>
    </div>
  );
};

export default PeopleCard;
